module.exports = __webpack_public_path__ + "fonts/3107C8_7_0.9c10c10.eot";